import React, { useContext, useEffect, useRef, useState } from 'react';
import "./style.css"
import Form from 'react-bootstrap/Form';
import { formatDateToUsaMMDDYYYY, LogInSchoolID, organizationName } from '../../JS/Common';
import { CheckValidation } from '../../Components/Validations';
import { ApiGetCall, ApiPostCall } from '../../JS/Connector';
import AlertsComp from '../../Components/AlertsComp';
import Tab from '../../Components/Tab';
import PageHead from '../../Components/PageHead';
import Popup from '../../Components/Popup';
import { UserContext } from '../../App';
import { hasRoleAccess, RoleEnum } from '../../JS/RoleType';
import useConfig from '../../Hooks/useConfig';
import { useLocation } from 'react-router-dom';

export default function DeviceCustomField() {
    const { UserData } = useContext(UserContext);
    const { role, copyrole, copyaccesstype } = UserData;
    const effectiveRole = copyrole || role || null;
    const AdminMenuAccessFlag = hasRoleAccess(effectiveRole, RoleEnum.ALL_ADMINS) && !copyaccesstype;
    const isAdmin = AdminMenuAccessFlag
    const { department, parent_guardian_email, parent_guardian_name, parent_phone_number,
        show_device_complete_club, adminCallNode, dcc_module_text } = useConfig();
    const [ansType, setAnsType] = useState('1')
    const [RequiredField, setRequiredField] = useState(0)
    const [EditableField, setEditableField] = useState(0)
    const [parentObject, setParentObject] = useState(1)
    const [fields, setFields] = useState([
        { id: 1, value: '', flag: 1, structureID: 0, can_delete: true },
    ]);
    const [FieldName, setFieldName] = useState('')
    const [FieldType, setFieldType] = useState('')
    const [FieldPriority, setFieldPriority] = useState('')
    const [FieldColor, setFieldColor] = useState('#000')
    const colorRef = useRef()
    const [FieldNameError, setFieldNameError] = useState('')
    const [ansTypeError, setAnsTypeError] = useState('')
    const [SubEntryError, setSubEntryError] = useState('')
    const [NewAlerts, setNewAlerts] = useState('');
    const [loading, setLoading] = useState(false);
    const [typeAndPriorityData, setTypeAndPriorityData] = useState([]);
    const [customField, setCustomField] = useState([])
    const [AddupdateFlag, setAddupdateFlag] = useState('')
    const [AdminFields, setAdminFields] = useState([])
    const [ExistingFields, setExistingFields] = useState([
        { name: 'Serial Number', type: 'Text' },
        { name: 'Device Model', type: 'Text' },
        { name: 'Device MPN', type: 'Text' },
        { name: 'Repair Cap', type: 'Number' },
        { name: 'Building', type: 'Text' },
        { name: 'Device Manufacturer', type: 'Text' },
        { name: 'Asset Tag', type: 'Text' },
        { name: 'Device OS', type: 'Text' },
        { name: 'Notes', type: 'Text' },
        { name: 'Purchase Date', type: 'Date' },
        { name: 'Expected Retirement', type: 'Date' },
        { name: 'Manufacturer Warranty Until', type: 'Date' },
        { name: 'Manufacturer ADP Until', type: 'Date' },
        { name: 'Third Party Extended Warranty Until', type: 'Date' },
        { name: 'Third Party ADP Until', type: 'Date' },
        { name: 'Is this device a loaner device?', type: 'Single Selection' },
        { name: 'Do you want to assign this device to user?', type: 'Single Selection' },
        { name: 'Device User First Name', type: 'Text' },
        { name: 'Device User Middle Name', type: 'Text' },
        { name: 'Device User Last Name', type: 'Text' },
        { name: 'User ID', type: 'Text' },
        { name: department, type: 'Text' },
        {
            name: parent_guardian_email,
            type: 'Text'
        },
        { name: parent_guardian_name, type: 'Text' },
        { name: parent_phone_number, type: 'Number' },
        hasRoleAccess(UserData.copyrole || UserData.role || null, RoleEnum.COMN_EXCLUDE_VAR) && show_device_complete_club ?
            { name: dcc_module_text, type: 'Single Selection' }
            : null,
    ])
    const [Tabs, setTabs] = useState({
        Current: 'active',
        Existing: '',
        Admin: ''
    })
    const [CustomeModal, setCustomeModal] = useState(false)
    const [EditId, setEditId] = useState('')

    useEffect(() => {
        GetCustomFieldsNames();
        if (isAdmin) {
            GetTypeAndFieldPriority()
        }
    }, [])

    async function GetTypeAndFieldPriority() {
        setLoading(true)
        await ApiGetCall(`/custom-field/type-and-priority`).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                setLoading(false)
                const responseRs = JSON.parse(result);
                setTypeAndPriorityData(responseRs)
            }
        })
    }
    async function GetCustomFieldsNames() {
        setLoading(true)
        await ApiGetCall(`${isAdmin ? adminCallNode : ''}/custom-fields/names?schoolId=${LogInSchoolID}`).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                setLoading(false)
                const responseRs = JSON.parse(result);
                setCustomField(responseRs)
                setLoading(false);
            }
        });
    }
    async function GetFieldInfoCall(id) {
        setLoading(true)
        setAddupdateFlag(2)
        await ApiGetCall(`${isAdmin ? adminCallNode : ''}/custom-fields/by-id?uuid=${id}`).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                const responseRs = JSON.parse(result);
                setFieldName(responseRs?.name)
                setAnsType(responseRs?.value_type)
                setRequiredField(responseRs?.is_required)
                setEditableField(responseRs?.is_system_locked)
                setParentObject(responseRs?.parent_object_type)
                setCustomeModal(true);
                setLoading(false)
                setEditId(responseRs?.id)
                const updatedrow = responseRs?.customfieldstructures.map(item => item.custom_field_id != null ? { ...item, flag: 2, structureID: item.id } : { ...item, flag: 1, structureID: 0 })
                setFields(updatedrow)
                setFieldColor(responseRs?.color || '#000')
                setFieldType(responseRs?.function_type_code || '')
                setFieldPriority(responseRs?.priority || '')
            }
        });
    }

    function handleAddField() {
        setFields([...fields, { id: fields.length + 1, value: '', flag: 1, structureID: 0, can_delete: true }]);
        setTimeout(() => {
            const inputs = document.querySelectorAll('input.form-control');
            const lastInput = inputs[inputs.length - 1];
            lastInput?.focus();
        }, 0);
    };

    function handleRemoveField(fieldId) {
        setFields(fields.map((field) => {
            if (field.id === fieldId) {
                return { ...field, flag: 3 };
            }
            return field;
        }).map((field, index) => ({ ...field, id: index + 1 })));
    };


    function handleChange(event, fieldId) {
        const updatedFields = [...fields];
        const index = updatedFields.findIndex((field) => field.id === fieldId);
        updatedFields[index].value = event.target.value;
        setFields(updatedFields);
    };

    const renderFields = () => {
        let seriesId = 1;
        return fields.map((field) => {
            if (field.flag === 3) {
                return null;
            }
            const seriesLabel = `Option ${seriesId++}`;
            return (
                <div key={field.id} className='d-flex py-1 col-md-12 align-items-center'>
                    <div className='col-md-2 FormLabel'>{seriesLabel}:</div>
                    <div className='col-md-8'>
                        <input
                            className="form-control"
                            type="text"
                            flag={field.flag}
                            id={`field-${field.id}`}
                            name={`field-${field.id}`}
                            value={field.value}
                            onChange={(event) => handleChange(event, field.id)}
                            onKeyDown={(event) => { (event.key === "Enter" || event.keyCode === 13) && handleAddField() }}
                            required
                        />
                    </div>
                    {fields.length > 1 && field.can_delete && (
                        <img src="/images/delete_red_icon.svg" title="Delete Option"
                            className="img-fluid cursor-pointer ps-2" onClick={() => handleRemoveField(field.id)} />
                    )}
                    <br />
                </div>
            );
        });
    };



    function handleRadioChange(flag) {
        setAnsType(flag)
        setFields([{ id: 1, value: '', flag: 1, structureID: 0 }]);
    }

    async function SaveFieldCall() {
        setAnsTypeError('* required')
        var valuesArray = []
        const checkvalidation = fields.filter(item => !(item.flag == 3 && item.structureID == 0));
        if (ansType == 6 || ansType == 7) {
            if (checkvalidation.filter(item => item.value.trim() === "").length != 0) {
                setSubEntryError('* All fields are required');
                return;
            } else {
                const newArray = fields.filter(item => !(item.flag == 3 && item.structureID == 0));
                valuesArray = newArray.map(item => item.value);
                setSubEntryError('');
            }
        }
        if ((ansType == 6 || ansType == 7) && valuesArray.length == 0) {
            setNewAlerts(<AlertsComp show={true} variant={"danger"} msg={"Please add options for the selected custom field."} />)
            setTimeout(() => {
                setNewAlerts(<AlertsComp show={false} />);
            }, 2000);
            return;
        }
        const hasDuplicateNames = (() => {
            const names = checkvalidation.map(item => item.value);
            return new Set(names).size !== names.length;
        })();
        if ((ansType == 6 || ansType == 7) && hasDuplicateNames) {
            setNewAlerts(<AlertsComp show={true} variant={"danger"} msg={"More than one option with the same name can't exists."} />)
            setTimeout(() => {
                setNewAlerts(<AlertsComp show={false} />);
            }, 2000);
            return;
        }
        var isFormValid = CheckValidation({ formID: "RequiredID" });
        if (!isFormValid) return;

        var nameRegex = /^[a-zA-Z0-9\s()&]+$/;
        if (!nameRegex.test(FieldName)) {
            setFieldNameError('* only the following special characters are allowed: (, ), &');
            return;
        }

        var raw = JSON.stringify({
            schoolId: LogInSchoolID,
            name: FieldName,
            type: ansType,
            isRequired: RequiredField,
            subType: valuesArray,
            parentObjectType: parentObject,
            functionTypeId: FieldType,
            priority: FieldPriority,
            color: FieldColor,
            isSystemLocked: EditableField,
        })
        setLoading(true)
        await ApiPostCall(`${isAdmin ? adminCallNode : ''}/custom-fields/save`, raw).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                setLoading(false);
                if (result == "success") {
                    setCustomeModal(false)
                    if (isAdmin) {
                        GetTypeAndFieldPriority()
                    }

                    setNewAlerts(<AlertsComp show={true} variant="success" msg={"Field Added Successfully"} />);
                    setTimeout(() => {
                        setNewAlerts(<AlertsComp show={false} />);
                        GetCustomFieldsNames();
                        setFieldName(''); setRequiredField(0); setEditableField(0); setParentObject(1); setFields([{ id: 1, value: '' }])
                    }, 1500);
                } else {
                    const responseRs = JSON.parse(result);
                    setNewAlerts(<AlertsComp show={true} variant="danger" msg={responseRs.response} />);
                    setTimeout(() => {
                        setNewAlerts(<AlertsComp show={false} />)
                    }, 2000);
                }
            }
        });
    }

    async function UpdateFieldCall(flag, deleteId) {
        var updateArray = [];
        {
            fields.map((item, i) => {
                var vjson = {};
                vjson['flag'] = item.flag;
                vjson['name'] = item.value;
                vjson['structureID'] = item.structureID;
                updateArray.push(vjson)
            })
        }
        var newArray;
        const checkvalidation = updateArray.filter(item => !(item.flag == 3));
        if (flag == 1) {
            newArray = updateArray.filter(item => item.name.trim() !== '' && !(item.flag === 3 && item.structureID === 0));
            setAnsTypeError('* required')
            if (ansType == 6 || ansType == 7) {
                if (checkvalidation.filter(item => item.name.trim() === "").length != 0) {
                    setSubEntryError('* All fields are required');
                    return;
                } else {
                    setSubEntryError('');
                }
            }
            var isFormValid = CheckValidation({ formID: "RequiredID" });
            if (!isFormValid) return;

            var nameRegex = /^[a-zA-Z0-9\s()&]+$/;
            if (!nameRegex.test(FieldName)) {
                setFieldNameError('* only the following special characters are allowed: (, ), &');
                return;
            }
        }

        if ((ansType == 6 || ansType == 7) && checkvalidation.length == 0) {
            setNewAlerts(<AlertsComp show={true} variant={"danger"} msg={"Please add options for the selected custom field."} />)
            setTimeout(() => {
                setNewAlerts(<AlertsComp show={false} />);
            }, 2000);
            return;
        }
        const hasDuplicateNames = (() => {
            const names = checkvalidation.map(item => item.name);
            return new Set(names).size !== names.length;
        })();
        if ((ansType == 6 || ansType == 7) && hasDuplicateNames) {
            setNewAlerts(<AlertsComp show={true} variant={"danger"} msg={"More than one option with the same name can't exists."} />)
            setTimeout(() => {
                setNewAlerts(<AlertsComp show={false} />);
            }, 2000);
            return;
        }

        var raw = JSON.stringify({
            schoolId: LogInSchoolID,
            name: FieldName,
            valueType: ansType,
            isRequired: RequiredField,
            parentObjectType: parentObject,
            structureArray: newArray,
            customFieldId: flag == 1 ? EditId : deleteId,
            updateDeleteFlag: flag,
            isSystemLocked: EditableField,
            functionTypeId: FieldType,
            priority: FieldPriority,
            color: FieldColor,
        })
        setLoading(true)
        await ApiPostCall(`${isAdmin ? adminCallNode : ''}/custom-fields/update-delete`, raw).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                setLoading(false);
                const responseRs = JSON.parse(result)
                if (responseRs.status == "success") {
                    setCustomeModal(false)
                    GetTypeAndFieldPriority()
                    setNewAlerts(<AlertsComp show={true} variant="success" msg={responseRs.msg} />);
                    setTimeout(() => {
                        setNewAlerts(<AlertsComp show={false} />);
                        GetCustomFieldsNames();
                        setFieldName(''); setRequiredField(0); setEditableField(0); setParentObject(1); setFields([{ id: 1, value: '' }])
                    }, 1500);
                } else {
                    setNewAlerts(<AlertsComp show={true} variant="danger" msg={responseRs.msg} />);
                    setTimeout(() => {
                        setNewAlerts(<AlertsComp show={false} />)
                    }, 2000);
                }
            }
        });
    }
    function handleTabClick(tabType) {
        if (tabType == "current") {
            setTabs({ ...Tabs, Current: "active", Existing: "", Admin: "" });
            GetCustomFieldsNames();
        } else if (tabType == "default") {
            setTabs({ ...Tabs, Current: "", Existing: "active", Admin: "" });
        } else if (tabType == "admin") {
            setTabs({ ...Tabs, Current: "", Existing: "", Admin: "active" });
        }
    }
    const modalbody = (
        <div id="RequiredID">
            {(isAdmin) &&
                <div className='d-flex align-items-center mb-2'>
                    <div>Field for:</div>
                    <div className='d-flex'>
                        <div className="my-2 ms-3">
                            <Form.Check type="radio" name="group5" aria-label="radio 1" label="Device" onChange={(e) => { setParentObject(1) }} checked={parentObject == 1} disabled={AddupdateFlag == 2} />
                        </div>
                        <div className="my-2 ms-3">
                            <Form.Check type="radio" name="group5" aria-label="radio 1" label="Ticket" onChange={(e) => { setParentObject(2); setFieldType(''); setFieldPriority(''); setFieldColor('#000'); }} checked={parentObject == 2} disabled={AddupdateFlag == 2} />
                        </div>
                    </div>
                </div>
            }

            <div className="d-flex col-md-12 align-items-center parent">
                <div className="col-md-2"> Field Name:<label className='redText'>*</label></div>
                <div className='ps-4 col-md-6'>
                    <input className="form-control" autoComplete='off' name='add field' placeholder='Enter Field Name' required value={FieldName} onChange={(e) => { setFieldName(e.target.value); setFieldNameError(''); }} />
                    <span className="form-text invalid-feedback"> *required </span>
                    {FieldNameError && <div className="Emailinvalid pt-1">{FieldNameError}</div>}
                </div>
                <br />
            </div>
            {(isAdmin && parentObject == 1) &&
                <>
                    <div className='d-flex col-md-12 align-items-center pt-3'>
                        <div className="col-md-2"> Additional Functions:</div>

                        <div className='ps-4 col-md-6'>
                            <select value={FieldType} onChange={(e) => { setFieldType(e.target.value); handleRadioChange(4); }}>
                                <option value="0">None</option>
                                {typeAndPriorityData?.custom_field_types?.map((field) => (
                                    <option value={field?.code}>{field?.name}</option>
                                ))}
                            </select>
                        </div>
                    </div>
                    {FieldType == '1' &&
                        <>
                            <div className='d-flex col-md-12 align-items-center pt-3'>
                                <div className="col-md-2">
                                    Field Priority:
                                    <label className='redText'>*</label>
                                    <span className="tooltip-wrapper">
                                        <img
                                            src="/images/InfoIcon.svg"
                                            className="info-icon"
                                            height="14"
                                            alt="info"
                                        />
                                        <span className="tooltip-text">
                                            Priority being added to the field will determine the order in which the fields are displayed on the device having active coverage. The higher the number, the higher the priority.
                                        </span>
                                    </span>
                                </div>

                                <div className='ps-4 col-md-6 parent'>
                                    <select value={FieldPriority} required onChange={(e) => { setFieldPriority(e.target.value) }}>
                                        <option value="">None</option>
                                        {typeAndPriorityData?.priorities?.map((field) => (
                                            <option disabled={field?.flag === 0} value={field?.priority}>{field?.priority}</option>
                                        ))}
                                    </select>
                                    <span className="form-text invalid-feedback"> *required </span>
                                </div>
                            </div>
                            <div className='d-flex col-md-12 align-items-center pt-3'>
                                <div className="col-md-2">Field Colour:</div>

                                <div className='ps-4 col-md-6'>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={FieldColor}
                                        readOnly
                                        onClick={() => colorRef.current.showPicker?.()}
                                        placeholder="Select Color"
                                    />

                                    <input
                                        ref={colorRef}
                                        type="color"
                                        value={FieldColor}
                                        onChange={(e) => setFieldColor(e.target.value)}
                                        style={{
                                            position: "absolute",
                                            // width: "1px",
                                            // height: "1px",
                                            opacity: 0,
                                            pointerEvents: "none"
                                        }}
                                    />
                                </div>
                            </div>
                        </>
                    }

                </>
            }
            <div className="d-flex col-md-12 pt-3">
                <div className="col-md-2"> Field Type:</div>
                <div className='ps-4 col-md-10'>
                    <div className='row'>
                        <div className="col-6 my-2">
                            <Form.Check type="radio" name="group1" aria-label="radio 1" label="Small Text (max character 100)" onChange={(e) => { handleRadioChange(1) }} checked={ansType == 1} defaultChecked disabled={AddupdateFlag == 2 || FieldType == '1'} />
                        </div>
                        <div className="col-3 my-2">
                            <Form.Check type="radio" name="group1" aria-label="radio 1" label="Long Text" onChange={(e) => { handleRadioChange(2) }} checked={ansType == 2} disabled={AddupdateFlag == 2 || FieldType == '1'} />
                        </div>
                        <div className="col-3 my-2">
                            <Form.Check type="radio" name="group1" aria-label="radio 1" label="Number" onChange={(e) => { handleRadioChange(3) }} checked={ansType == 3} disabled={AddupdateFlag == 2 || FieldType == '1'} />
                        </div>
                        <div className="col-3 my-2">
                            <Form.Check type="radio" name="group1" aria-label="radio 1" label="Date" onChange={(e) => { handleRadioChange(4) }} checked={ansType == 4} disabled={AddupdateFlag == 2} />
                        </div>
                        <div className="col-3 my-2">
                            <Form.Check type="radio" name="group1" aria-label="radio 1" label="Date & Time" onChange={(e) => { handleRadioChange(5) }} checked={ansType == 5} disabled={AddupdateFlag == 2} />
                        </div>
                        <div className="col-3 my-2">
                            <Form.Check type="radio" name="group1" aria-label="radio 1" label="Single Selection" onChange={(e) => { handleRadioChange(6) }} checked={ansType == 6} disabled={AddupdateFlag == 2 || FieldType == '1'} />
                        </div>
                        <div className="col-3 my-2">
                            <Form.Check type="radio" name="group1" aria-label="radio 1" label="Multi Selection" onChange={(e) => { handleRadioChange(7) }} checked={ansType == 7} disabled={AddupdateFlag == 2 || FieldType == '1'} />
                        </div>
                        <div className='col-3 my-2'></div>
                        {ansType == '' ?
                            <div className="Emailinvalid col-12" id='statusMsg'>{ansTypeError}</div>
                            : <></>}

                        {ansType == 6 || ansType == 7 ? (
                            <div className='d-flex col-md-12 mb-3'>
                                <div className='greyBox p-3 col-md-12'>
                                    <div className='font-16 fw-600'>{ansType == 6 ? 'Options for Single Selection' : 'Options for Multi Selection'}</div>
                                    <hr />
                                    <form onSubmit={(e) => e.preventDefault()}>
                                        {renderFields()}
                                    </form>
                                    <div className="col-md-8 offset-md-2 Emailinvalid" id='statusMsg'>{SubEntryError}</div>

                                    <div className='row col-md-12'>
                                        <div className='col-md-8 offset-md-2 pt-1'>
                                            <label className='BorderBtn text-center' onClick={handleAddField}>
                                                <img src='/images/AddInventory.svg' className='img-fluid pe-2' style={{ height: '12px' }} />Add
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) : (<></>)}
                    </div>
                </div>
            </div>
            <div className='d-flex align-items-center'>
                <div>Make this field mandatory?</div>
                <div className='d-flex'>
                    <div className="my-2 ms-3">
                        <Form.Check type="radio" name="group2" aria-label="radio 1" label="Yes" onChange={(e) => { setRequiredField(1); setEditableField(0); }} checked={RequiredField == 1} />
                    </div>
                    <div className="my-2 ms-3">
                        <Form.Check type="radio" name="group2" aria-label="radio 1" label="No" onChange={(e) => { setRequiredField(0) }} checked={RequiredField == 0} />
                    </div>
                </div>
            </div>
            {isAdmin &&
                <div className='d-flex align-items-center'>
                    <div>What access should the {organizationName} have for this field?</div>
                    <div className='d-flex'>
                        <div className="my-2 ms-3">
                            <Form.Check type="radio" name="group3" aria-label="radio 1" label="View & Edit" onChange={(e) => { setEditableField(0) }} checked={EditableField == 0} />
                        </div>
                        <div className="my-2 ms-3">
                            <Form.Check type="radio" name="group3" aria-label="radio 1" label="View Only" onChange={(e) => { setEditableField(1) }} checked={EditableField == 1} disabled={RequiredField == 1} />
                        </div>
                        <div className="my-2 ms-3">
                            <Form.Check type="radio" name="group3" aria-label="radio 1" label="Admin Only" onChange={(e) => { setEditableField(2) }} checked={EditableField == 2} />
                        </div>
                    </div>
                </div>
            }
        </div>
    )
    return (
        <React.Fragment>
            <PageHead heading={`${isAdmin ? 'Manage Custom Fields' : 'Manage Device Fields'}`}
                loading={loading} Alerts={NewAlerts} showsearch={false} />
            <div className="GridBox p-3 mt-3">
                <div className="row align-items-center">
                    <div className="col-md-9 px-0">
                        {!isAdmin &&
                            <ul className="nav nav-tabs px-3">
                                <Tab isActive={Tabs.Current == 'active'}
                                    label="Custom Fields" onClick={() => handleTabClick('current')} col={'col-md-3'} />
                                <Tab isActive={Tabs.Existing == 'active'}
                                    label="Default Existing" onClick={() => handleTabClick('default')} col={'col-md-3'} />
                                {/* <Tab isActive={Tabs.Admin == 'active'}
                                    label="Admin Custom" onClick={() => handleTabClick('admin')} col={'col-md-3'} /> */}
                            </ul>
                        }
                    </div>
                    <div className="col-md-3 text-end">
                        {Tabs.Current == 'active' && (
                            <label className='BorderBtn ms-3 text-center' onClick={(e) => { setCustomeModal(true); setAnsTypeError(''); setSubEntryError(''); setFields([{ id: 1, value: '' }]); setAnsType('1'); setRequiredField(0); setEditableField(0); setParentObject(1); setAddupdateFlag(1); setFieldNameError(''); setFieldColor("#000"); setFieldPriority(''); setFieldType('') }}> Add Field
                                <img src='/images/AddInventory.svg' className='img-fluid ps-2' />
                            </label>
                        )}
                    </div>
                </div>

                <div className="greyBox mt-2">
                    {Tabs.Current == 'active' && (
                        <table className="table data-table">
                            <thead className='GridHeader'>
                                <tr>
                                    <th scope="col" className='fw-600'>Name </th>
                                    <th scope="col" className='fw-600'>Type </th>
                                    <th scope="col" className='fw-600'>Field for</th>
                                    {
                                        isAdmin &&
                                        <>
                                            <th scope="col" className='fw-600'>Additional Functions</th>
                                            <th scope="col" className='fw-600'>Priority</th>
                                        </>
                                    }
                                    <th scope="col" className='fw-600'>Created at </th>
                                    <th scope="col" className='fw-600'>Action </th>
                                </tr>
                            </thead>
                            <tbody>
                                {customField.length != 0 ?
                                    customField.map((item, i) => {
                                        return <tr key={i} className="OddEvenClass tableBorderHide">
                                            <td className="py-12">{item.name || "-"} </td>
                                            <td className="py-12">{item.value_type_name || "-"} </td>
                                            <td className="py-12">{item.parent_object_type == 1 ? 'Device' : item.parent_object_type == 2 ? 'Ticket' : '-'} </td>
                                            {isAdmin &&
                                                <>
                                                    <td className="py-12">{item.function_type_name ? item.function_type_name : '-'} </td>
                                                    <td className="py-12">{item.priority ? item.priority : '-'} </td>
                                                </>
                                            }
                                            <td className="py-12">{item.created_at ? formatDateToUsaMMDDYYYY(item.created_at) : '-'} </td>
                                            <td className='py-12'>
                                                {item.school_id ?
                                                    (
                                                        <>
                                                            <img src='/images/EditIconNew.svg' title='Edit Field' className='img-fluid pe-2 cursor-pointer' onClick={(e) => { GetFieldInfoCall(item.id); }} />
                                                            <img src='/images/DeleteIcon.svg' title='Delete Field' className='img-fluid pe-2 cursor-pointer' onClick={(e) => { UpdateFieldCall(2, item.id); }} />

                                                        </>
                                                    ) :
                                                    <>
                                                        {AdminMenuAccessFlag ?
                                                            <img src='/images/EditIconNew.svg' title='Edit Field' className='img-fluid pe-2 cursor-pointer' onClick={(e) => { GetFieldInfoCall(item.id); }} />
                                                            : '-'}
                                                    </>
                                                }
                                            </td>
                                        </tr>
                                    })
                                    :
                                    <tr className="text-center">
                                        <td colSpan={15}>No Record Found</td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    )}
                    {Tabs.Existing == 'active' && (
                        <table className="table data-table">
                            <thead className='GridHeader'>
                                <tr>
                                    <th scope="col" className='fw-600'>Name </th>
                                    <th scope="col" className='fw-600'>Type </th>
                                </tr>
                            </thead>
                            <tbody>
                                {ExistingFields.length != 0 ?
                                    ExistingFields.map((item, i) => {
                                        return <tr key={i} className="OddEvenClass tableBorderHide">
                                            <td className="py-12" >{item?.name} </td>
                                            <td className="py-12" >{item?.type} </td>
                                        </tr>
                                    })
                                    :
                                    <tr className="text-center">
                                        <td colSpan={15}>No Record Found</td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    )}
                    {Tabs.Admin == 'active' && (
                        <table className="table data-table">
                            <thead className='GridHeader'>
                                <tr>
                                    <th scope="col" className='fw-600'>Name </th>
                                    <th scope="col" className='fw-600'>Type </th>
                                </tr>
                            </thead>
                            <tbody>
                                {AdminFields.length != 0 ?
                                    AdminFields.map((item, i) => {
                                        return <tr key={i} className="OddEvenClass tableBorderHide">
                                            <td className="py-12" >{item?.name} </td>
                                            <td className="py-12" >{item?.value_type_name} </td>
                                        </tr>
                                    })
                                    :
                                    <tr className="text-center">
                                        <td colSpan={15}>No Record Found</td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    )}
                </div>
            </div>
            <Popup isshow={CustomeModal} size={"lg"} title={AddupdateFlag == 2 ? 'Edit Field' : 'Add Field'}
                closePopup={(e) => { setCustomeModal(false); setFieldName(''); setRequiredField(0); setEditableField(0); setParentObject(1); setFields([{ id: 1, value: '' }]); setFieldNameError(''); }}
                modalBody={modalbody} handleSave={(e) => AddupdateFlag == 2 ? UpdateFieldCall(1, null) : SaveFieldCall()}
                visibleSaveBtn={true} btnText={AddupdateFlag == 2 ? 'Update' : 'Save'} />
        </React.Fragment >
    )
}
